
export { PortalItemType } from "/www/app/apps/core/src/constants/types.ts"